import { render, staticRenderFns } from "./dept-notification-dialog.vue?vue&type=template&id=7ce4c746&scoped=true"
import script from "./dept-notification-dialog.vue?vue&type=script&lang=js"
export * from "./dept-notification-dialog.vue?vue&type=script&lang=js"
import style0 from "./dept-notification-dialog.vue?vue&type=style&index=0&id=7ce4c746&prod&scoped=true&lang=css"
import style1 from "./dept-notification-dialog.vue?vue&type=style&index=1&id=7ce4c746&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce4c746",
  null
  
)

export default component.exports